import * as React from 'react';
import { Header } from '@cak-legacy/shared-common';
import './FormSectionContainer.scss';
import { FieldSchema } from '@cak-legacy/generation-core';
import { HintPopup } from '../Components/HintPopup';
import { withHideOnFieldHoc } from '../Hoc/withHideOnFieldHoc';

export interface IFormSectionContainerProps {
  name: string;
  field: FieldSchema;
  children: React.ReactNode;
}

export const FormSectionContainer = withHideOnFieldHoc((props: IFormSectionContainerProps) => {
  const flexDirection = props.field.ui?.formOverview?.flexDirection ?? props.field.ui?.flexDirection ?? 'row';
  const id = 'id' in props.field ? `${props.field.id}-container` : undefined;
  const popUpHintHeaderClass = props.field.popupHint ? 'd-inline-block' : '';
  const formsectionPopup = props.field.popupHint ? 'formsection-container__popup-hint' : '';
  return (
    <div
      {...(id ? { id } : {})}
      className={`formsection-container formsection-container__${flexDirection} ${formsectionPopup}`}
    >
      <Header headerType="h2" headerText={props.field.label ?? ''} classes={`${popUpHintHeaderClass}`} />
      {props.field.popupHint && <HintPopup fieldId={props.name} popupHint={props.field.popupHint} />}
      <div
        className={`fieldset-container fieldset-container--${
          props.field.ui?.theme ?? 'dark'
        } flexdirection-${flexDirection}`}
      >
        {props.field.subLabel && <label className="formsection-container--subLabel">{props.field.subLabel}</label>}
        {props.children}
      </div>
    </div>
  );
});
